import React from 'react';

import { useEngeneNavigate } from '../hooks/navigate';

const NavigateGoBack: React.FunctionComponent = () => {
  const navigate = useEngeneNavigate();

  setTimeout(() => navigate(-1), 0);

  return <>GO BACK</>;
};

export default NavigateGoBack;
